import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface AppLog {
	id: string;
	createdAt: string;
	level: string;
	app: string;
	message: string;
	metadata: Record<string, unknown> | null;
	trace: string | null;
}

export interface AdminLogsFilters {
	level?: string | undefined;
	app?: string | undefined;
	search?: string | undefined;
	from?: string | undefined;
	to?: string | undefined;
	limit?: number | undefined;
	offset?: number | undefined;
}

export interface AdminLogsResponse {
	items: AppLog[];
	total: number;
}

const KEY = "admin-logs";

export function useAdminLogs(filters: AdminLogsFilters) {
	const queryParams = new URLSearchParams();
	if (filters.level) queryParams.set("level", filters.level);
	if (filters.app) queryParams.set("app", filters.app);
	if (filters.search) queryParams.set("search", filters.search);
	if (filters.from) queryParams.set("from", filters.from);
	if (filters.to) queryParams.set("to", filters.to);
	if (filters.limit !== undefined) queryParams.set("limit", String(filters.limit));
	if (filters.offset !== undefined) queryParams.set("offset", String(filters.offset));

	return useQuery({
		queryKey: [KEY, filters],
		queryFn: () => api.get<AdminLogsResponse>(`/api/admin/logs?${queryParams.toString()}`),
	});
}
